export default {
  state: {
    token: undefined,
    userdata: {},
    is_authenticated: false,
    sources: [],
    notification: null
  },

  mutations: {
    JWTOKEN(state, token) {
      state.token = token;
      state.is_authenticated = true;
    },
    USERDATA(state, userdata) {
      state.userdata = userdata;      
    },
    LOGOUT: state => {
      state.token = undefined;
      state.is_authenticated = false;
      state.stream_base_url = undefined;
      state.supported_stream_formats = undefined;
      state.stream_token = undefined;
    },
    SOURCES: (state, sources) => {
      state.sources = sources
    },
    setNotification(state, notification) {
      state.notification = notification;
    }
  },

  actions: {
    SET_JWTOKEN({ commit }, token) {
      localStorage.setItem("token", token);
      commit('JWTOKEN', token);
    },
    SET_USERDATA({ commit }, userdata) {
      localStorage.setItem("userdata", userdata);
      commit('USERDATA', userdata);
    },
    SET_SOURCES({ commit }, sources) {
      localStorage.setItem("sources", sources);
      commit('SOURCES', sources);
    },
    SET_LOGOUT({ commit }) {
      localStorage.removeItem('token');
      commit('LOGOUT');
    },
    SET_NOTIFICATION({ commit }, notification) {
      commit('setNotification', notification);
    }
  },

  getters: {
    is_authenticated: state => {
      return state.is_authenticated;
    },
    is_staff: state => {
      if (state.is_authenticated) {
        return state.userdata.is_staff;
      }
      return false;
    },
    get_jwtoken: () => {
      return localStorage.getItem("token");
    },
    get_userdata: state => { 
      return state.userdata;
    },
    get_sources: state => {
      return state.sources;
    },
    notification: state => {
      return state.notification;
    }

  }
}